<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    @click="closeModal"
  >
    <div
      class="bg-white dark:bg-bgLightDark rounded-lg shadow-xl w-80 max-w-sm mx-4"
      @click.stop
    >
      <!-- Header -->
      <div class="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-600">
        <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
          {{ $t('calculator') }}
        </h3>
        <button
          @click="closeModal"
          class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
        >
          <i class="fa-solid fa-times text-xl"></i>
        </button>
      </div>

       <!-- Calculator Display -->
       <div class="p-4">
         <div class="bg-gray-100 dark:bg-gray-700 rounded-lg p-4 mb-4">
           <div class="text-right text-sm font-mono text-gray-600 dark:text-gray-300 min-h-[1.5rem] mb-2">
             {{ expression }}
           </div>
           <div class="text-right text-2xl font-mono text-gray-900 dark:text-white min-h-[2rem]">
             {{ display }}
           </div>
         </div>
         
       
        <!-- Calculator Buttons -->
        <div class="grid grid-cols-4 gap-2">
          <!-- Row 1 -->
          <button
            @click="clear"
            class="col-span-2 bg-red-500 hover:bg-red-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            {{ $t('clear') }}
          </button>
          <button
            @click="deleteLast"
            class="bg-gray-500 hover:bg-gray-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            <i class="fa-solid fa-backspace"></i>
          </button>
          <button
            @click="inputOperator('/')"
            class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            ÷
          </button>

          <!-- Row 2 -->
          <button
            @click="inputNumber('7')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            7
          </button>
          <button
            @click="inputNumber('8')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            8
          </button>
          <button
            @click="inputNumber('9')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            9
          </button>
          <button
            @click="inputOperator('*')"
            class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            ×
          </button>

          <!-- Row 3 -->
          <button
            @click="inputNumber('4')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            4
          </button>
          <button
            @click="inputNumber('5')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            5
          </button>
          <button
            @click="inputNumber('6')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            6
          </button>
          <button
            @click="inputOperator('-')"
            class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            −
          </button>

          <!-- Row 4 -->
          <button
            @click="inputNumber('1')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            1
          </button>
          <button
            @click="inputNumber('2')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            2
          </button>
          <button
            @click="inputNumber('3')"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            3
          </button>
          <button
            @click="inputOperator('+')"
            class="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            +
          </button>

          <!-- Row 5 -->
          <button
            @click="inputNumber('0')"
            class="col-span-2 bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            0
          </button>
          <button
            @click="inputDecimal"
            class="bg-gray-300 hover:bg-gray-400 dark:bg-gray-600 dark:hover:bg-gray-500 text-gray-900 dark:text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            .
          </button>
          <button
            @click="calculate"
            class="bg-green-500 hover:bg-green-600 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
          >
            =
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalculatorModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'open-calculator'],
   data() {
     return {
       display: '0',
       expression: '',
      previousValue: null,
      operator: null,
      waitingForNewValue: false,
      lastInput: null,
      keyboardListenerAdded: false
     }
  },
  mounted() {
    // Add global keyboard listener for automatic calculator input
    document.addEventListener('keydown', this.handleGlobalKeyPress)
  },
  activated() {
    // Component activated (for keep-alive components)
    if (this.isOpen) {
      this.$nextTick(() => {
        if (!this.keyboardListenerAdded) {
          document.addEventListener('keydown', this.handleKeyPress)
          this.keyboardListenerAdded = true
        }
      })
    }
  },
  deactivated() {
    // Component deactivated (for keep-alive components)
    if (this.keyboardListenerAdded) {
      document.removeEventListener('keydown', this.handleKeyPress)
      this.keyboardListenerAdded = false
    }
  },
  beforeUnmount() {
    // Remove all event listeners when component is unmounted
    document.removeEventListener('keydown', this.handleKeyPress)
    document.removeEventListener('keydown', this.handleGlobalKeyPress)
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // When modal opens, add keyboard listener after next tick
        this.$nextTick(() => {
          if (!this.keyboardListenerAdded) {
            document.addEventListener('keydown', this.handleKeyPress)
            this.keyboardListenerAdded = true
          }
        })
      } else {
        // When modal closes, remove keyboard listener
        if (this.keyboardListenerAdded) {
          document.removeEventListener('keydown', this.handleKeyPress)
          this.keyboardListenerAdded = false
        }
        // Reset calculator state
        this.resetCalculator()
      }
    }
  },
  methods: {
    handleKeyPress(event) {
      // Only handle keyboard input when calculator is open
      if (!this.isOpen) return
      
      // Prevent default behavior for calculator keys
      if (this.isCalculatorKey(event.key)) {
        event.preventDefault()
      }
      
      // Handle number keys (0-9)
      if (event.key >= '0' && event.key <= '9') {
        this.inputNumber(event.key)
      }
      // Handle decimal point
      else if (event.key === '.' || event.key === ',') {
        this.inputDecimal()
      }
      // Handle operators
      else if (event.key === '+') {
        this.inputOperator('+')
      }
      else if (event.key === '-') {
        this.inputOperator('-')
      }
      else if (event.key === '*') {
        this.inputOperator('*')
      }
      else if (event.key === '/') {
        this.inputOperator('/')
      }
      // Handle equals/enter
      else if (event.key === '=' || event.key === 'Enter') {
        this.calculate()
      }
      // Handle clear/escape
      else if (event.key === 'Escape' || event.key === 'c' || event.key === 'C') {
        this.clear()
      }
      // Handle backspace/delete
      else if (event.key === 'Backspace' || event.key === 'Delete') {
        this.deleteLast()
      }
    },
    isCalculatorKey(key) {
      const calculatorKeys = [
        '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        '.', ',', '+', '-', '*', '/', '=', 'Enter', 'Escape',
        'c', 'C', 'Backspace', 'Delete'
      ]
      return calculatorKeys.includes(key)
    },
    handleGlobalKeyPress(event) {
      // Only handle if calculator is not open and we're not in an input field
      if (this.isOpen) return
      
      const target = event.target
      const isInputField = target.tagName === 'INPUT' || 
                          target.tagName === 'TEXTAREA' || 
                          target.contentEditable === 'true' ||
                          target.isContentEditable
      
      if (isInputField) return
      
      // Check if the key is a number or mathematical operator
      const key = event.key
      const isNumber = key >= '0' && key <= '9'
      const isOperator = ['+', '-', '*', '/', '='].includes(key)
      const isDecimal = key === '.' || key === ','
      const isEnter = key === 'Enter'
      
      if (isNumber || isOperator || isDecimal || isEnter) {
        // Prevent default behavior
        event.preventDefault()
        
        // Open calculator if not already open
        if (!this.isOpen) {
          this.$emit('open-calculator')
        }
        
        // Process the key
        if (isNumber) {
          this.inputNumber(key)
        } else if (isOperator) {
          this.inputOperator(key)
        } else if (isDecimal) {
          this.inputDecimal()
        } else if (isEnter) {
          this.calculate()
        }
      }
    },
    closeModal() {
      console.log('CalculatorModal: closeModal called')
      // Remove keyboard listener before closing
      if (this.keyboardListenerAdded) {
        document.removeEventListener('keydown', this.handleKeyPress)
        this.keyboardListenerAdded = false
        console.log('CalculatorModal: keyboard listener removed')
      }
      // Reset calculator state
      this.resetCalculator()
      // Emit close event
      this.$emit('close')
    },
     inputNumber(number) {
       if (this.lastInput === 'operator' || this.lastInput === 'equals' || this.lastInput === null) {
         this.display = number
         if (this.lastInput === 'operator') {
           this.expression += number
         } else {
           this.expression = number
         }
       } else {
         this.display = this.display === '0' ? number : this.display + number
         this.expression = this.expression === '' ? number : this.expression + number
       }
       this.lastInput = 'number'
     },
     inputDecimal() {
       if (this.lastInput === 'operator' || this.lastInput === 'equals' || this.lastInput === null) {
         this.display = '0.'
         if (this.lastInput === 'operator') {
           this.expression += '0.'
         } else {
           this.expression = '0.'
         }
       } else if (this.display.indexOf('.') === -1) {
         this.display += '.'
         this.expression += '.'
       }
       this.lastInput = 'number'
     },
     inputOperator(operator) {
       if (this.lastInput === 'number') {
         // If we have a number, add the operator
         this.expression += this.getOperatorSymbol(operator)
         this.lastInput = 'operator'
       } else if (this.lastInput === 'equals') {
         // If we just calculated, start a new expression with the result
         this.expression = this.display + this.getOperatorSymbol(operator)
         this.lastInput = 'operator'
       } else if (this.lastInput === 'operator') {
         // Replace the last operator if user clicks another operator
         this.expression = this.expression.slice(0, -1) + this.getOperatorSymbol(operator)
         this.lastInput = 'operator'
       }
     },
     getOperatorSymbol(operator) {
       switch (operator) {
         case '+': return '+'
         case '-': return '−'
         case '*': return '×'
         case '/': return '÷'
         default: return operator
       }
     },
     calculate() {
       if (this.expression && (this.lastInput === 'number' || this.lastInput === 'operator')) {
         try {
           // If last input was operator, remove it before calculating
           let expressionToCalculate = this.expression
           if (this.lastInput === 'operator') {
             expressionToCalculate = this.expression.slice(0, -1)
           }
           
           // Replace display symbols with calculation symbols
           let calcExpression = expressionToCalculate
             .replace(/×/g, '*')
             .replace(/÷/g, '/')
             .replace(/−/g, '-')
           
           // Evaluate the expression safely
           const result = this.evaluateExpression(calcExpression)
           this.display = String(result)
           this.expression = expressionToCalculate + '='
           this.lastInput = 'equals'
         } catch (error) {
           this.display = 'Error'
           this.expression = ''
           this.lastInput = 'error'
         }
       }
     },
     evaluateExpression(expression) {
       // Use a safer evaluation method
       try {
         // Replace display symbols with calculation symbols
         let calcExpression = expression
           .replace(/×/g, '*')
           .replace(/÷/g, '/')
           .replace(/−/g, '-')
           .replace(/\s/g, '')
         
         // Simple validation - only allow numbers, operators, and parentheses
         if (!/^[\d+\-*/.()\s]+$/.test(calcExpression)) {
           throw new Error('Invalid characters in expression')
         }
         
         // Use Function constructor for safer evaluation than eval
         const result = new Function('return ' + calcExpression)()
         
         if (typeof result !== 'number' || isNaN(result) || !isFinite(result)) {
           throw new Error('Invalid result')
         }
         
         return result
       } catch (error) {
         throw new Error('Invalid expression')
       }
     },
    clear() {
      this.display = '0'
      this.expression = ''
      this.lastInput = null
    },
    resetCalculator() {
      this.display = '0'
      this.expression = ''
      this.previousValue = null
      this.operator = null
      this.waitingForNewValue = false
      this.lastInput = null
    },
     deleteLast() {
       if (this.lastInput === 'equals' || this.lastInput === 'error') {
         this.clear()
         return
       }
       
       if (this.display.length > 1) {
         this.display = this.display.slice(0, -1)
         this.expression = this.expression.slice(0, -1)
       } else {
         this.display = '0'
         this.expression = ''
         this.lastInput = null
       }
     }
   }
}
</script>

<style scoped>
/* Custom scrollbar for dark mode */
:deep(.dark) .bg-gray-100 {
  background-color: #374151;
}

:deep(.dark) .bg-gray-300 {
  background-color: #4B5563;
}

:deep(.dark) .bg-gray-400 {
  background-color: #6B7280;
}

:deep(.dark) .bg-gray-500 {
  background-color: #9CA3AF;
}

:deep(.dark) .bg-gray-600 {
  background-color: #4B5563;
}

:deep(.dark) .bg-gray-700 {
  background-color: #374151;
}

/* Button hover effects */
button:active {
  transform: scale(0.95);
}

/* Smooth transitions */
button {
  transition: all 0.2s ease-in-out;
}
</style>
